import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase-config";
import { notifyPermissionDenied } from "../handleCallableError";

const dealershipRequest = (data) => ({
  ...(data || {}),
  requestedApp: "dealership_web",
});

const callableError = (error, message) => {
  notifyPermissionDenied(error);
  return { success: "no", message, error: error.message };
};

export const createLoan = async (data) => {
  try {
    const fn = httpsCallable(functions, "createLoanV2");
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error("Error creating loan:", error);
    return callableError(error, "Error al crear el préstamo");
  }
};

export const getLoansByDealership = async (data) => {
  try {
    const fn = httpsCallable(functions, "getLoansByDealershipV2");
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error("Error getting loans:", error);
    return callableError(error, "Error al obtener los préstamos");
  }
};

export const getLoanById = async (data) => {
  try {
    const fn = httpsCallable(functions, "getLoanByIdV2");
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error("Error getting loan:", error);
    return callableError(error, "Error al obtener el préstamo");
  }
};

export const checkLoanAvailability = async (data) => {
  try {
    const fn = httpsCallable(functions, "checkLoanAvailabilityV2");
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error("Error checking loan availability:", error);
    return callableError(
      error,
      "Error al verificar la disponibilidad del vehículo",
    );
  }
};

export const getCarSchedule = async (data) => {
  try {
    const fn = httpsCallable(functions, "getCarScheduleV2");
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error("Error getting car schedule:", error);
    return callableError(error, "Error al obtener la agenda del vehículo");
  }
};

export const updateLoan = async (data) => {
  try {
    const fn = httpsCallable(functions, "updateLoanV2");
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error("Error updating loan:", error);
    return callableError(error, "Error al actualizar el préstamo");
  }
};

export const cancelLoan = async (data) => {
  try {
    const fn = httpsCallable(functions, "cancelLoanV2");
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error("Error cancelling loan:", error);
    return callableError(error, "Error al cancelar el préstamo");
  }
};

export const editLoan = async (data) => {
  try {
    const fn = httpsCallable(functions, "editLoanV2");
    const result = await fn(dealershipRequest(data));
    return result.data;
  } catch (error) {
    console.error("Error editing loan:", error);
    return callableError(error, "Error al editar el préstamo");
  }
};

export const getLoanForSigning = async (data) => {
  try {
    const fn = httpsCallable(functions, "getLoanForSigningV2");
    const result = await fn(data);
    return result.data;
  } catch (error) {
    console.error("Error getting loan for signing:", error);
    return {
      success: "no",
      message: "El enlace de firma no es válido",
      error: error.message,
    };
  }
};

export const signLoan = async (data) => {
  try {
    const fn = httpsCallable(functions, "signLoanV2");
    const result = await fn(data);
    return result.data;
  } catch (error) {
    console.error("Error signing loan:", error);
    return {
      success: "no",
      message: error?.message || "Error al firmar el préstamo",
      error: error.message,
    };
  }
};
